import { ButtonHTMLAttributes } from "react";
import styled, { css } from "styled-components";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  $variant?: "primary" | "secondary" | "delete" | "discord";
  $icon?: React.ReactElement;
  $withBorder?: boolean;
  $active?: boolean;
}

export const StyledButton = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 0.5rem 2rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${({ $variant, theme }) =>
    $variant === "delete"
      ? css`
          background-color: ${theme.colors.error};
          color: ${theme.colors.white};

          &:hover {
            background-color: ${theme.colors.error}; /* slightly darker red */
          }
          &:focus {
            outline: none;
            box-shadow: 0 0 0 3px ${theme.colors.subtle_8};
          }
        `
      : $variant === "secondary"
        ? css`
            background-color: ${theme.colors.appSecondary};
            color: ${theme.colors.white};

            &:hover {
              background-color: ${theme.colors.appTertiary};
            }
            &:active {
              background-color: ${theme.colors.primary};
            }
            &:focus {
              outline: none;
              box-shadow: 0 0 0 3px ${theme.colors.subtle_8};
            }
          `
        : $variant === "discord"
          ? css`
              background-color: ${theme.colors.discord};
              color: ${theme.colors.white};

              &:hover {
                background-color: ${`${theme.colors.discord}B3`};
              }
              &:active {
                background-color: ${`${theme.colors.discord}D9`};
              }
            `
          : css`
              background-color: ${theme.colors.primary};
              color: ${theme.colors.white};

              &:hover {
                background-color: ${theme.colors.appTertiary};
              }
              &:active {
                background-color: ${theme.colors.appSecondary};
              }
              &:focus {
                outline: none;
                box-shadow: 0 0 0 3px ${theme.colors.subtle_8};
              }
            `}

  ${({ $withBorder, theme }) =>
    $withBorder &&
    css`
      border: 2px solid ${theme.colors.white};
    `}

  ${({ $icon, $variant }) =>
    $icon && $variant !== "discord"
      ? css`
          gap: 0.5rem;
          svg {
            width: 1em;
            height: 1em;
          }
        `
      : css`
          gap: 0.5rem;
          svg {
            width: 2em;
            height: 2em;
          }
        `}

  ${({ $active, theme }) =>
    $active &&
    css`
      box-shadow: 0 0 0 3px ${theme.colors.subtle};
    `}
`;
